import { render, staticRenderFns } from "./RiskLocationTypologyStep.vue?vue&type=template&id=2d47168a&"
import script from "./RiskLocationTypologyStep.vue?vue&type=script&lang=js&"
export * from "./RiskLocationTypologyStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports